import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import { MenuFoldOutlined } from '@ant-design/icons';
import NavbarMenus from "../../components/navbarMenus";
import Header from "../../components/header";
const UpdateLog = () => {
    return (
        <div className={styles.modules}>
            <div className={styles.navbar} id='nav'>
                <NavbarMenus path="UpdateLog"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='更新日志'></Header>

                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[2.8.4] - 2024-12-27
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复轴坐标最后一个元素无法显示问题<br/>
                        * 修复饼图数据全为0时异常的问题<br/>
                        * 修复折线图动态切换数据时X轴属性重复显示的问题
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 柱状图新增自定义设置每根柱子的label颜色
                        * 折线图新增显示尾部标签
                    </p>
                    <h4>优化</h4>
                    <p>
                        * 优化饼图的指标连接线重叠的算法
                    </p>

                    <div className={styles.title}>
                        <span>#</span>[2.8.3] - 2024-12-05
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复折线图更新时闪退异常的问题<br/>
                        * 修复横向条形图点击提示层显示异常的问题<br/>
                        * 修复雷达图设置区域渐变色之后边框颜色失效的问题<br/>
                        * 修复提示层设置false无效的问题<br/>
                        * 修复雷达图点配置 borderWidth 边框宽度borderColor 边框颜色属性无法生效的问题
                    </p>
                    <h4>优化</h4>
                    <p>
                        * 优化饼图判断label为空时，连接线清空的问题<br/>
                        * 优化折线图连接线拐角过尖的问题<br/>
                        * 新增提示层回调增加点击位置对应index的属性
                    </p>

                    <div className={styles.title}>
                        <span>#</span>[2.8.2] - 2024-11-28
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修復多线程使用之后无关闭导致内存溢出的问题<br/>
                        * 修复折线图x轴数据比实例数据多的情况下无法显示折线图的问题<br/>
                        * 修复折线图更新数据时异常的问题<br/>
                        * 修复title更新异常的问题<br/>
                        * 修复条形图提示框位置异常的问题
                    </p>

                    <div className={styles.title}>
                        <span>#</span>[2.8.1] - 2024-11-25
                    </div>
                    <h4>优化</h4>
                    <p>
                        * 优化新版本的鸿蒙系统闪退的问题
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.8.0] - 2024-11-01
                    </div>
                    <h4>全新版本体验</h4>
                    <p>
                        * 优化整体设计结构，提高维护性以及拓展性<br/>
                        * 增加每个图表组件的动画帧属性，让图表动起来更加丝滑<br />
                        * 调整部分图表的参数使用方式与属性
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 新增Y轴支持设置min跟max值<br/>
                        * 新增设置双Y轴属性<br/>
                        * 新增图例可支持点击控制对应实例显示与隐藏<br/>
                        * 新增折线+柱状组合图表<br/>
                        * 新增仪表盘图表<br/>
                        * 新增梯形柱状图<br/>
                        * 柱状图新增设置渐变色<br/>
                        * 柱状图新增背景颜色<br/>
                        * 新增玫瑰饼状图<br/>
                        * 雷达图新增圆形模式<br/>
                        * 新增网格实例属性设置图表内部间距
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.9] - 2024-08-12
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复折线图label无法自定义显示的问题<br/>
                        * 修复条形图滚动模式的触发方式<br/>
                        * 修复柱状图滚动模式下提示框显示异常的问题<br/>
                        * 修复柱状图的动画影响渲染的问题<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.8] - 2024-08-05
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复页面同时渲染多个图表时，渲染数据异常的问题<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.7] - 2024-08-01
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复饼图文本标签配置异常<br/>
                        * 修复柱状图label无法设置隐藏的问题<br/>
                        * 修复柱状图因动画问题渲染不完整的问题<br/>
                        * 修复饼图的文本标签连接线异常的问题<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.6] - 2024-07-29
                    </div>
                    <h4>修复</h4>
                    <p>
                        * 修复数据处理异常的问题<br/>
                    </p>
                    <h4>优化</h4>
                    <p>
                        * 优化数据监听的逻辑，避免重复监听<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.5] - 2024-07-29
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 折线图数据全部为零的时候悬浮异常<br/>
                        * 折线图数据滚动与缩放时渲染异常的问题<br/>
                        * 折线图数据圆滑曲线时尾部渲染异常的问题<br/>
                        * 修复折线图渲染面积图异常的问题<br/>
                        * 修复雷达图更新数据与提示层异常渲染的问题<br/>
                        * 优化柱状图文本标签渲染顺序以及动画渲染异常<br/>
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 折线图支持设置尾部形状
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.4] - 2024-07-25
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 修复5.0.0版本以上的编辑器无法使用自定义提示层的构造函数<br/>
                        * 修复折线图折线数据与y轴数据对不上的问题<br/>
                        * 修复图表右边距离设置无效<br/>
                        * 优化折线图的默认动画与更新动画效果<br/>
                        * 优化柱状图的默认动画与更新动画效果<br/>
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 新增横向柱状图图表组件
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.3] - 2024-07-22
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 修复x轴label标签截取与换行渲染异常的问题<br/>
                        * 修复柱状图动画渲染异常的问题<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.2] - 2024-07-16
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 紧急修复柱状图数据为0时，数据显示异常的问题<br/>
                        * 修复x轴间隔支持设置全部展示<br/>
                        * 优化饼图的渲染逻辑<br/>
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 新增饼图增加设置角度
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.1] - 2024-07-15
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 修复动态更新数据时，series需要传输全部参数，否则会还原为初始值<br/>
                        * 修复饼图连接线渲染异常的问题<br/>
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 新增饼图增加title组件以及自定义设置title的功能
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V2.0.0] - 2024-07-11
                    </div>
                    <h4>修复与优化</h4>
                    <p>
                        * 修复Tooltip中的app.float.xxxx资源引用不到，编译不通过的问题<br/>
                        * 修复设置自定义属性必须要把属性写全，否则会丢失默认值的问题<br/>
                        * 修复折线图设置x轴的label和刻度尺的时候，会导致x轴的文本不显示出来的问题<br/>
                        * 修复折线图x轴的data设置为number类型的数组会报错的问题<br/>
                        * 修复series的data数据类型定义错误的问题<br/>
                        * 修复@state defOptions: Options = new Options({})时会报错<br/>
                        * 修复不显示tooltip情况下点击扇区报错的问题<br/>
                        * 修复柱状图X轴文本没有和图对齐的问题<br/>
                        * 优化基础颜色样式<br/>
                        * 优化折线图的排版样式<br/>
                        * 优化x轴的样式<br/>
                    </p>
                    <h4>新增</h4>
                    <p>
                        * 新增折线图支持设置平滑曲线<br/>
                        * 新增X轴文本支持设置直接截断与换行<br/>
                        * 新增X轴动态设置间隔显示文本标签<br/>
                        * 新增X轴支持设置滚动模式<br/>
                        * 新增X轴支持设置文本与轴线的距离<br/>
                        * 新增Y轴支持设置名称与轴线的距离<br/>
                        * 新增Y轴支持设置文本与轴线的距离<br/>
                        * 新增折线图支持设置背景面积图<br/>
                        * 新增折线图支持设置拐点边框样式<br/>
                        * 新增柱状图支持设置圆柱属性<br/>
                        * 新增自定义提示框<br/>
                        * 新增雷达图组件<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V1.0.2] - 2024-02-02
                    </div>
                    <p>
                        * 适配所有图表支持API9+以上的版本
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V1.0.1] - 2024-01-24
                    </div>
                    <p>
                        * 优化整体数据刷新的逻辑以及传参的模式<br/>
                        * 修复图例无法隐藏的问题<br/>
                        * 修复图例文本位置出现偏差的问题<br/>
                        * 修复Y轴线的刻度样式 <br/>
                        * 修复Y轴线隐藏导致整体渲染异常的问题<br/>
                        * 修复内边距渲染异常的问题<br/>
                        * 修复文本标签的位置偏差以及渲染层级<br/>
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>[V1.0.0] - 2024-01-18
                    </div>
                    <p>
                        * 初始化项目 <br/>
                        * 实现折线图组件相关功能<br/>
                        * 实现柱状图组件相关功能<br/>
                        * 实现饼图组件相关功能<br/>
                        * 实现散点图组件相关功能
                    </p>
                </div>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default UpdateLog
